import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Button, CdnIcon, Price, ReviewBadge, Span, cn } from "@pcln/horizon";
import { recentSelectionVariants } from "../RecentSelection.variants.js";
function DateBlock({ airportCodes, className, dateClassName, dateInfo, label, labelClassName, productType }) {
    const { dateBlock, dateBlockDate, dateBlockLabel } = recentSelectionVariants({
        productType
    });
    return /*#__PURE__*/ jsxs("div", {
        className: cn(dateBlock(), className),
        children: [
            /*#__PURE__*/ jsx(Span, {
                className: cn(dateBlockLabel(), labelClassName),
                children: label
            }),
            /*#__PURE__*/ jsxs(Span, {
                className: cn(dateBlockDate(), dateClassName),
                children: [
                    dateInfo.date ?? '',
                    dateInfo.time && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx("br", {}),
                            /*#__PURE__*/ jsx("span", {
                                className: "text-body2",
                                children: dateInfo.time
                            })
                        ]
                    }),
                    airportCodes && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx("br", {}),
                            /*#__PURE__*/ jsx("span", {
                                className: "text-body2",
                                children: airportCodes
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function ReviewsSection({ reviews, starRating }) {
    const { reviewsSection, reviewsText } = recentSelectionVariants();
    const shouldShowReviews = reviews.rating && reviews.reviewCount && starRating;
    return shouldShowReviews ? /*#__PURE__*/ jsxs("div", {
        className: reviewsSection(),
        children: [
            /*#__PURE__*/ jsx(ReviewBadge, {
                rating: reviews.rating,
                size: "sm"
            }),
            /*#__PURE__*/ jsxs(Span, {
                className: reviewsText(),
                children: [
                    reviews.reviewCount,
                    " Reviews",
                    ` | ${starRating} Star`
                ]
            })
        ]
    }) : null;
}
function PriceSection({ price }) {
    const { priceSection } = recentSelectionVariants();
    const currencySymbol = price.currencySymbol ?? '$';
    const priceDescription = price.priceContext ?? '';
    return /*#__PURE__*/ jsxs("div", {
        className: priceSection(),
        children: [
            /*#__PURE__*/ jsx(Price, {
                type: "priceSecondary",
                price: price.totalPrice,
                currencySymbol: currencySymbol,
                textStyle: "heading3",
                isFormatted: true,
                bold: true
            }),
            priceDescription && /*#__PURE__*/ jsx(Span, {
                className: "text-body3 text-neutral-10",
                children: priceDescription
            })
        ]
    });
}
function OccupancySection({ iconName, text }) {
    const { occupancyBlock, occupancyText } = recentSelectionVariants();
    return /*#__PURE__*/ jsxs("div", {
        className: occupancyBlock(),
        children: [
            /*#__PURE__*/ jsx(CdnIcon, {
                className: "text-neutral-13",
                iconName: iconName,
                size: "20"
            }),
            /*#__PURE__*/ jsx(Span, {
                className: occupancyText(),
                children: text
            })
        ]
    });
}
function CTAButtons({ buttonText, onClick }) {
    const { ctaContainer } = recentSelectionVariants();
    function handleClick(e) {
        e.stopPropagation();
        onClick?.();
    }
    return /*#__PURE__*/ jsx("div", {
        className: ctaContainer(),
        children: /*#__PURE__*/ jsx(Button, {
            fullWidth: true,
            onClick: handleClick,
            size: "md",
            slots: {
                buttonSlot: '@3xl:rounded-action-sm',
                wrapperSlot: '@3xl:min-h-8 @3xl:px-2 @3xl:py-1'
            },
            type: "primaryShop",
            children: buttonText
        })
    });
}
export { CTAButtons, DateBlock, OccupancySection, PriceSection, ReviewsSection };
